// import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import Vue from 'vue'
// import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import customThemes from './themes.js'

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },

    themes: {
      light: {
        ...customThemes.light
      },
      dark: {
        ...customThemes.dark
      },
    },

  },
});
